module.exports = __webpack_public_path__ + "media/images/top/topics-top-b5dc76fcee685a7c4622e583ffb821a3.svg";